import mitt from 'mitt'

export const EmitterEvents = {
  firstAuditNoPassModal: 'firstAuditNoPassModal', // 首次关闭不通过评论弹窗
  onShowMessageNotification: 'onShowMessageNotification', // 消息提示
  fastAccess: 'fastAccess'
}

const emitter = mitt()

export default emitter
